import { render, staticRenderFns } from "./agora.vue?vue&type=template&id=402c27b5&scoped=true"
import script from "./agora.vue?vue&type=script&lang=js"
export * from "./agora.vue?vue&type=script&lang=js"
import style0 from "./agora.vue?vue&type=style&index=0&id=402c27b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402c27b5",
  null
  
)

export default component.exports